// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "::ng-deep .k-grid {\n  height: 100%;\n}\n::ng-deep .k-grid .k-grid-content.k-virtual-content {\n  overflow-y: auto;\n}\n::ng-deep .k-grid tr {\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
